import { Component, inject, signal, effect } from '@angular/core';
import { LayoutShellComponent, UserInfo } from '@olonera/layout';
import { NavigationConfigService } from '@olonera/layout';
import { AuthService } from '@olonera/auth';
import { Router } from '@angular/router';
import { PatientService } from '@olonera/api';
import { PageTitleService } from '@olonera/shared';

@Component({
  selector: 'app-authenticated-layout',
  standalone: true,
  imports: [LayoutShellComponent],
  template: `
    <lib-layout-shell
      [navSections]="navSections"
      [pageTitle]="pageTitleService.pageTitle()"
      [pageSubtitle]="pageTitleService.pageSubtitle()"
      [user]="user()"
      userSubtitle="Early Perimenopause · Premium"
      role="Patient"
      (logout)="onLogout()"
      (settingsClick)="onSettingsClick()"
      (profileClick)="onProfileClick()"
      (notificationClick)="onNotificationClick()"
      (ordersClick)="onOrdersClick()"
    >
    </lib-layout-shell>
  `,
  styles: [`
    :host {
      display: block;
      height: 100vh;
    }
  `]
})
export class AuthenticatedLayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly navConfig = inject(NavigationConfigService);
  private readonly router = inject(Router);
  private readonly patientService = inject(PatientService);
  protected readonly pageTitleService = inject(PageTitleService);

  user = signal<UserInfo | null>(null);
  navSections = this.navConfig.getPatientNav();
  private lastSyncedUserId: string | null = null;

  constructor() {
    effect(() => {
      const userDto = this.authService.currentUser();
      if (userDto) {
        if (userDto.id !== this.lastSyncedUserId) {
          this.lastSyncedUserId = userDto.id;

          this.patientService.getMyProfile().subscribe({
            next: (profile: any) => {
              this.user.set({
                firstName: userDto.firstName,
                lastName: userDto.lastName,
                email: userDto.email,
                avatarUrl: profile.profilePhotoUrl || undefined
              });
            },
            error: () => {
              this.user.set({
                firstName: userDto.firstName,
                lastName: userDto.lastName,
                email: userDto.email,
              });
            }
          });
        }
      }
    });
  }

  onLogout(): void {
    this.authService.logout();
  }

  onSettingsClick(): void {
    this.router.navigate(['/settings']);
  }

  onProfileClick(): void {
    this.router.navigate(['/settings']);
  }

  onNotificationClick(): void {
    // Handle notification click
  }

  onOrdersClick(): void {
    this.router.navigate(['/orders']);
  }
}
